module.exports = __webpack_public_path__ + "static/media/csm.bc9d3ff6.png";